// extracted by mini-css-extract-plugin
export default {"dragzone":"Style_dragzone__SeAgc","dragging":"Style_dragging__3AECv"};